<template>
    <div class="shenqingDiv">
        <div class="center">
            <h4>教培机构一站式数字化解决方案</h4>
            <div class="btn shenqing bgRed" @click="openDialog('免费试用',0)">申请试用</div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    created(){

    },
    mounted(){

    },
    methods:{
        openDialog:function(title,type){//type:(0机构,1微官网)
              this.$parent.$parent.$refs.openPop.openDialog(title,type);
          }
    }
}
</script>

<style scoped lang="less">
    .shenqingDiv{
        width: 100%;
        height:200px;
        background:url("https://cdntest.yizhiniao.com/newWebsite_/common/footer_weibu.png")no-repeat center;
        .center{
            padding: 50px 0;
            text-align:center;
            h4{
                font-size: 30px;
                font-weight: 500;
                color: #9F5B5B;
                line-height: 42px;
                margin-bottom: 24px;
            }
            .btn{
                width:100px;
                height: 34px;
                font-size: 16px;
                line-height:22px;
                padding:6px 17px;
                margin: 0 auto;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/shenqing.vue